import { ApiErrorData, ApiResponse } from '../models/ApiResponse';
import { Company } from '../models/Company';
import { FunctionsHelper } from '../utils/FunctionsHelper';
import MainBackendAxios from '../utils/MainBackendAxios';

export const CompanyService = {
  updateCustomConfigByCurrentUser: async (
    params: UpdateCustomConfigByCurrentUserRequestDto,
    file?: File
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const formData = new FormData();
      formData.append('primaryColor', params.primaryColor);
      formData.append('secondaryColor', params.secondaryColor);
      formData.append('itemSelectedBg', params.itemSelectedBg);
      formData.append('itemSelectedColor', params.itemSelectedColor);
      formData.append('itemActiveBg', params.itemActiveBg);

      if (params.logoHeight) {
        formData.append('logoHeight', `${params.logoHeight}`);
      }

      if (file) {
        formData.append('file', file);
      }

      const response = await MainBackendAxios.put(
        `/company/update-custom-config-by-current-user`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getAll: async (): Promise<ApiResponse<Company[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`/company/get-all`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getAllFilteredByCurrentUser: async (): Promise<
    ApiResponse<Company[] | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.get(
        `/company/get-all-filtered-by-current-user`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  findById: async (
    id: number
  ): Promise<ApiResponse<Company | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`/company/find-by-id/${id}`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  create: async (
    params: CreateCompanyRequestDto
  ): Promise<ApiResponse<{ createdId: number } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(`/company/create`, params);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  update: async (
    id: number,
    params: UpdateCompanyRequestDto
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(
        `/company/update/${id}`,
        params
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  updateReporteAccessSecret: async (
    id: number,
    params: UpdateReporteAccessSecretRequestDto
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(
        `/company/report/update-secret/${id}`,
        params
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};

export interface UpdateCustomConfigByCurrentUserRequestDto {
  primaryColor: string;
  secondaryColor: string;
  itemSelectedBg: string;
  itemActiveBg: string;
  itemSelectedColor: string;
  logoHeight?: number;
}

export interface CreateCompanyRequestDto {
  name: string;
  countryCode: string;
  isPrivate: boolean;
  reportAccessSecret: string;
  kitIntegrationEnabled: boolean;
  kitCompanyIds: number[];
  tiendaPerfectaIntegrationEnabled: boolean;
  tiendaPerfectaCompanyCode: string | null;
}

export interface UpdateCompanyRequestDto {
  name: string;
  isPrivate: boolean;
  kitIntegrationEnabled: boolean;
  kitCompanyIds: number[];
  tiendaPerfectaIntegrationEnabled: boolean;
  tiendaPerfectaCompanyCode: string | null;
}

export interface UpdateReporteAccessSecretRequestDto {
  reportAccessSecret: string;
}
